import React from "react";
import presidentImg from "../assets/president.png";

export default function President() {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10 lg:gap-20 px-6 sm:px-10 lg:px-16 py-12 max-w-7xl mx-auto">
      <div className="text-center lg:text-left">
        <p className="hidden md:block text-5xl font-semibold text-[#1D4C60]">
          “
        </p>

        <h1 className="text-2xl sm:text-3xl font-semibold text-[#1D4C60] mb-4">
          President's Word
        </h1>

        <p className="mt-4 text-gray-600 max-w-xl mx-auto lg:mx-0">
          <span className="text-lg font-bold">
            Igniting Change, One Heartbeat at a Time
          </span>
          <br />
          As President of the Leo Club, University of Delhi for 2024-25, I am
          deeply honored to lead a group so driven by passion, empathy, and the
          desire to create lasting change. Together, we’ve envisioned a better
          world, and our united actions can truly transform lives. Our mission
          is clear: to ignite change through kindness, compassion, and service,
          inspiring both ourselves and our community. Every project and act of
          service creates ripples of positive transformation, pushing the
          boundaries of what we can achieve together. As we move forward, let’s
          stay committed to our shared goal of building a more compassionate
          world. With hope, pride, and determination, I believe this year will
          be one of remarkable progress and impact.
        </p>

        <h3 className="mt-6 text-lg text-[#1D4C60] font-bold">
          Leo Kanishk Verma
        </h3>
        <p className="text-gray-600">
          President, Leo Club, University of Delhi
        </p>
      </div>

      <div className="flex justify-center lg:justify-end">
        <img
          src={presidentImg}
          alt="President"
          className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-sm rounded-lg shadow-lg object-cover"
        />
      </div>
    </section>
  );
}
